let React = require("react");
const {  NavLink  } = require('react-router-dom');

let SearchBox = require("./search/SearchBox.jsx");

class SubNavigationBar extends React.Component {

    constructor(){
        super();
        this.state = {type: ""};
    }

    isExplore(path){
        return /\/(search|explore)$/gi.test(path);

        this.changePage = this.changePage.bind(this);
    }

    isSearchPage(){
        return this.props.match.path.includes("/search");
    }

    changePage(type){
        let { clearSearch = ()=>{} } = this.props;
        clearSearch(type == "packages");
        this.setState({type})
    }


    render() {
        let { setSearchValue, match: {path} } = this.props;

        if(/\/(packages|libraries|3dmodels|trash)$/gi.test(path)){
            path = path.slice(0, path.lastIndexOf("/"));
        }

        let isExplore = this.isExplore(path);

        return  <div className={this.isSearchPage() && this.props.search ? "subnav pageSearch" : "subnav"}>
                    <ul className="subnav__links">
                        {
                          // isExplore &&
                          //   <NavLink isActive={(match, {pathname}) => pathname === path} to={path} activeClassName="-active">Overview</NavLink>
                        }
                        <NavLink to={`${path}/libraries`} activeClassName="-active" onClick={()=>this.changePage("libraries")}>Libraries</NavLink>
                        <NavLink to={`${path}/packages`} activeClassName="-active" onClick={()=>this.changePage("packages")}>Packages</NavLink>
                        <NavLink to={`${path}/3dmodels`} activeClassName="-active" onClick={()=>this.changePage("models")}>3D Models</NavLink>
                        {!isExplore &&
                            <NavLink to={`${path}/trash`} activeClassName="-active">Trash</NavLink>}
                    </ul>
                    {this.props.search &&
                        <SearchBox onSetUrlLibraries={this.props.onSetUrlLibraries} setSearchValue={setSearchValue} isSearchPage={this.isSearchPage()} isExplore={isExplore} path={path} type={this.state.type}/>
                    }
                </div>
    }
};

module.exports = SubNavigationBar;
